import styled, { keyframes, css } from 'styled-components'
import { bounceIn } from 'react-animations'
import border from 'styles/border'
import { Container, Fonts } from 'components/base-ui'
import { LabelSemiBoldTiny } from 'components/base-ui/FontsV2'

const BounceAnimation = keyframes`${bounceIn}`

const CardStyled = css`
  display: flex;
  align-items: center;
  position: relative;
  padding: ${({ theme: { spacing } }) => `${spacing['2XL']} ${spacing.M}`};
  background: #ffffff;
  color: ${(props) => props.theme.colors.gray800};
`

export const CardEmpty = styled.div`
  ${CardStyled}
`

export const Card = styled.div<{ contentInside?: boolean }>`
  ${CardStyled}
  margin-bottom: 15px;
  font-size: ${({ theme }) => theme.fontSize.lg};

  &.-active {
    box-shadow: 0px 0px 0px 1px ${(props) => props.theme.colors.green500};
    background-color: ${(props) => props.theme.colors.green100};

    &::after {
      content: '\\e913';
      font-family: 'icons-indiedish' !important;
      font-size: 9px;
      display: flex;
      color: white;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: ${(props) => props.theme.colors.green500};
      position: absolute;
      top: 50%;
      margin-top: -12px;
      right: 15px;
      animation: ${BounceAnimation} 0.6s linear forwards;
    }
  }

  ${({ contentInside }) =>
    contentInside &&
    `
    display: block;

    &::after {
      top: 15px !important;
      margin-top: 0 !important;
    }
  `}
`

export const ListDetailCards = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 0;

  li::before {
    content: '·';
    font-size: 28px;
    font-weight: bold;
    margin-right: 8px;
    line-height: 0px;
    position: relative;
    top: 4px;
    margin-left: 10px;
  }
`

export const IconPaymentWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 36px;

  margin-top: -5px;
  margin-bottom: -5px;
  margin-right: -9px;
  position: relative;
  left: -11px;
`

export const CardGroup = styled.div`
  box-shadow: 0px 0px 0px 1px ${(props) => props.theme.colors.lightGrey};
  border-radius: ${border.radius.md}px;
  overflow: hidden;
  margin-bottom: 5px;

  ${Card} {
    margin-bottom: 0;
    box-shadow: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.lightGrey};
  }

  ${Card}:last-child {
    border-bottom: 0;
  }

  ${Card}::after {
    content: '\\e913';
    font-family: 'icons-indiedish' !important;
    font-size: 9px;
    display: flex;
    color: transparent;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: transparent;
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 15px;
    box-shadow: inset 0 0 0 2px ${(props) => props.theme.colors.lightGrey};
  }

  ${Card}.-active {
    box-shadow: none;
    background-color: white;
  }

  ${Card}.-active::after {
    content: '\\e913';
    font-family: 'icons-indiedish' !important;
    font-size: 9px;
    display: flex;
    color: white;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.primary};
    position: absolute;
    top: 50%;
    margin-top: -12px;
    right: 15px;
    animation: ${BounceAnimation} 0.6s linear forwards;
    box-shadow: none;
  }
`

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
`

export const BtnBackWrapper = styled.div`
  position: absolute;
  top: 17px;
  left: 0;

  ${Container} {
    position: relative;
  }
`

export const Title = styled.div`
  margin-bottom: 15px;
  font-weight: ${Fonts.weight.semiBold};
  font-size: 24px;
  color: ${(props) => props.theme.colors.gray800};
`

export const CardText = styled(Fonts.BaseTitleRegular)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.infoDark};
`

export const Space = styled.div<{ isShow: boolean }>`
  flex: ${({ isShow }) => (isShow ? 'auto' : 0)};
  transition: flex 0.2s ease-out;
`

export const StyledTitle = styled(Title)`
  color: black;
`

export const ButtonWrapperStickyBottom = styled.div`
  padding-top: 15px;
  padding-bottom: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const WrapperInfoBox = styled.div`
  margin-top: 25px;
`

export const ExpiredContainer = styled.div`
  border-radius: 4px;
  padding: ${({ theme }) => `${theme.spacing['4XS']} ${theme.spacing['3XS']}`};
  margin-left: ${({ theme }) => theme.spacing['3XS']};
  background: ${({ theme }) => theme.colors.red100};
`

export const ExpiredLabel = styled(LabelSemiBoldTiny)`
  color: ${({ theme }) => theme.colors.red700};
`
